import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SignInService} from './sign-in/sign-in.service';
import {UNDEFINED_AUTH_BASE_URL} from './tisa-auth.errors';
import {ApiModuleConfig} from '@tisa-group/cdk/models';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {TISA_AUTH_URL} from './tisa-auth.providers';
import {TisaAuthHttpService} from './tisa-auth-http.service';
import {SettingsService} from './settings/settings.service';
import {ConfigService} from './config/config.service';
import {ClientService} from './client/client.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    TisaAuthHttpService,
    SignInService,
    SettingsService,
    ConfigService,
    ClientService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class TisaAuthModule {
  static forRoot({api}: ApiModuleConfig): ModuleWithProviders<TisaAuthModule> {
    if (!api) throw UNDEFINED_AUTH_BASE_URL;

    return {
      ngModule: TisaAuthModule,
      providers: [
        {
          provide: TISA_AUTH_URL,
          useValue: api,
        },
      ],
    };
  }
}
